module.exports = __webpack_public_path__ + "img/finance-color.27a5eb4.svg";